import type {
  AuthDialogDefaultValues,
  AuthDialogIntent,
} from "@/components/auth/dialogs/auth-dialog";
import type { User } from "@/lib/types";
import { createContext, useContext } from "react";

export type DisplayAuthDialogParams = {
  intent?: AuthDialogIntent;
  defaultValues?: AuthDialogDefaultValues;
  onLoggedIn?: (user: User) => void | Promise<void>;
  title?: string;
  skipSegmentation?: boolean;
};

export type CurrentUserContext = {
  user: User | null;
  reloadUser: () => Promise<void>;
  updateUser: (data: Partial<User>) => void;
  logout: () => Promise<void>;
  loaded: boolean;
  displayAuthDialog: (args?: DisplayAuthDialogParams) => void;
};

export const userContext = createContext<CurrentUserContext>({
  user: null,
  reloadUser: async () => void 0,
  updateUser: async () => void 0,
  logout: async () => void 0,
  loaded: false,
  displayAuthDialog: () => void 0,
});

export function useCurrentUser() {
  const context = useContext(userContext);
  return context;
}
